import type { Breadcrumb } from '@ori/presentation-components';

import type { TopAreaApiResponse } from '../models';

export enum ActionName {
  SET_BANNER_DATA = 'SET_BANNER_DATA',
  SET_BREADCRUMBS_DATA = 'SET_BREADCRUMBS_DATA',
  SET_IS_SUBNAV_NESTED = 'SET_IS_SUBNAV_NESTED',
}

export function setBannerData(data: TopAreaApiResponse) {
  return { type: ActionName.SET_BANNER_DATA, data } as const;
}

export function setBreadCrumbsData(data: Breadcrumb[]) {
  return { type: ActionName.SET_BREADCRUMBS_DATA, data } as const;
}

export function setIsSubnavNested(data: boolean) {
  return { type: ActionName.SET_IS_SUBNAV_NESTED, data } as const;
}

const actions = [setBannerData, setBreadCrumbsData, setIsSubnavNested] as const;

export type ActionsType = ReturnType<(typeof actions)[number]>;

export default {
  setBannerData,
  setBreadCrumbsData,
  setIsSubnavNested,
};
